import React from 'react';

import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

const CreateEntityLink = ({ text, onClick, to, title }) => {
   return (
      <div className='clearfix pl-3'>
         {
            to
              && (
                 <Link {...(onClick ? { onClick: onClick } : {})} {...(to ? { 'to': to } : {})} title={title} style={{ fontSize: '16px' }}
                    className='btn btn-link text-dark-blue text-decoration-none d-inline-flex align-items-center'
                 >
                    <i style={{ fontSize: '20px' }} className='fas fa-plus-square text-dark-orange mr-2'/>
                    {text}
                 </Link>
              )
         }
         {
            !to
              && (
                 <Button
                    color='link'
                    onClick={onClick}
                    style={{ fontSize: '16px' }}
                    className='btn btn-link text-dark-blue text-decoration-none d-inline-flex align-items-center'>
                    <i style={{ fontSize: '20px' }} className='fas fa-plus-square text-dark-orange mr-2'/>
                    {text}
                 </Button>
              )
         }
      </div>
   );
};

CreateEntityLink.propTypes = {
   onClick: PropTypes.func,
   to: PropTypes.string,
   text: PropTypes.string,
   title: PropTypes.string,
};

CreateEntityLink.defaultProps = {
   onClick: null,
   to: undefined,
   text: 'Create',
   title: 'Create',
};

export default CreateEntityLink;
